import { render, staticRenderFns } from "./bookable-educator-list.vue?vue&type=template&id=a1af8cbe&scoped=true&"
import script from "./bookable-educator-list.vue?vue&type=script&lang=js&"
export * from "./bookable-educator-list.vue?vue&type=script&lang=js&"
import style0 from "./bookable-educator-list.vue?vue&type=style&index=0&id=a1af8cbe&lang=scss&scoped=true&"
import style1 from "./bookable-educator-list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1af8cbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VIcon,VPagination,VSwitch,VTextField})
